// extracted by mini-css-extract-plugin
export var articleCard = "article-card-module--article-card--f6bf3";
export var articleCardSm = "article-card-module--article-card-sm--55d2f";
export var articleDesc = "article-card-module--article-desc--1e48d";
export var articleImg = "article-card-module--article-img--53cc4";
export var articleTextWrapper = "article-card-module--article-text-wrapper--435c4";
export var articleTitle = "article-card-module--article-title--2b4a8";